import React, { useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import StepFirst from "../update-profile/contactdetail";
import StepSecond from "../update-profile/servicedetail";
import StepThird from "../update-profile/projectdetail";
import Submit from "../update-profile/submit";
import { UpdateDeveloperProfileSchema } from "../../validationSchema/authSchema";

const UpdateProfilePopup = () => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(25);
  const [check, setCheck] = useState(false);
  const [skill, setSkill] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [value, setValue] = useState({})
  const [allStepValue, setAllStepValue] = useState({})
  const [rate, setRate] = useState({})
  const [workHistory, setWorkHistory] = useState({});
  const [allWorkHistory, setAllWorkHistory] = useState([]);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(UpdateDeveloperProfileSchema),
  });

  const handleSignup = async (values) => {
    if (Object.keys(errors).length !== 0) return
    handleStepChange(1, 25)
    console.log('values------->>', values);
    setAllStepValue(values)
    // const res = await signup(values);
    // if (res.code !== 401) {
    //   setIsRegister(true);
    //   setTimeout(() => {
    //     setIsRegister(false);
    //     window.location.href = "/";
    //   }, 2000);
    // }
  };

  // const checkInputBlank = (dataObj) => {
  //   let isValid = true;
  //   for (let keyValue in dataObj) {
  //     if (!dataObj[keyValue] && isValid) isValid = false
  //   }
  // }

  const handleStepChange = (val, prog) => {
    console.log({ val, prog, step })
    if (val === -1 && step === 1) return;
    setStep(step + val);
    setProgress(progress + prog);
    getResourceStep(step + val);
    setAllStepValue({ ...allStepValue, ...value, skill: skill, ...rate })
  };

  const handleChange = (vl) => {
    if (vl.length > 0) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  };
  
  console.log('allStepValue----->', allStepValue);
  const getResourceStep = (stepComing) => {
    switch (stepComing) {
      case 1:
        return (
          <StepFirst
            handleStepChange={handleStepChange}
            handleSubmit={handleSubmit}
            handleSignup={handleSignup}
            register={register}
            errors={errors}
            handleChange={handleChange}
            check={check}
            setSelectedCountry={setSelectedCountry}
            selectedCountry={selectedCountry}
            selectedCity={selectedCity}
            setSelectedCity={setSelectedCity}
            selectedState={selectedState}
            setSelectedState={setSelectedState}
          />
        );
      case 2:
        return <StepSecond
          handleStepChange={handleStepChange}
          setSkill={setSkill}
          skill={skill}
          setValue={setValue}
          value={value}
          handleSubmit={handleSubmit}
          handleSignup={handleSignup}
          register={register}
          errors={errors}
        />;
      case 3:
        return <StepThird
          handleStepChange={handleStepChange}
          rate={rate}
          setRate={setRate}
          allWorkHistory={allWorkHistory}
          setAllWorkHistory={setAllWorkHistory}
          setWorkHistory={setWorkHistory}
          workHistory={workHistory} />;
      case 4:
        return <Submit handleStepChange={handleStepChange} />;
      default:
        return "";
    }
  };

  return (
    <div className='resource-popup-content'>
      <div className='resource-progressbar'>
        <ProgressBar
          completed={progress}
          bgColor='#ff990a'
          borderRadius='12px 12px 0 0'
          baseBgColor='#E0E0E0'
          labelColor='#000'
          maxCompleted={100}
        />
      </div>
      <div className='resource-popup-body'>{getResourceStep(step)}</div>
    </div>
  );
};

export default UpdateProfilePopup;
